module.exports = __webpack_public_path__ + "static/media/avatar-man@2x.0bd1967b.png";